import React, { useState } from "react";
import axios from "axios";
import { Trash2, Loader2, AlertTriangle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Input } from "./ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DeleteAllFirms = ({ headers, toast, onDone, count }) => {
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const close = () => { setOpen(false); setPassword(""); setConfirm(""); };

  const run = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/admin/firms/delete-all`, { password, confirm }, { headers });
      toast({ title: "Tüm işletmeler silindi", description: `${r.data.deleted.firms} işletme silindi, yedek alındı.` });
      close();
      onDone();
    } catch (e) {
      toast({ title: "Hata", description: e?.response?.data?.detail || "Silinemedi." });
    } finally { setBusy(false); }
  };

  return (
    <div className="bg-white rounded-2xl border border-[#F3C9CF] p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3" data-testid="delete-all-firms-card">
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-[#c0392b] mt-0.5 shrink-0" />
        <p className="text-sm text-[#5b4d4f]">
          Toplam <b data-testid="delete-all-firms-count">{count}</b> işletme. Tümünü ve bağlı verilerini (teklif, yorum, reklam/sahiplik talebi, sipariş) silmek için kullanın. İşlemden önce otomatik yedek alınır.
        </p>
      </div>
      <button onClick={() => setOpen(true)} disabled={!count} data-testid="delete-all-firms-btn"
        className="inline-flex items-center justify-center gap-2 px-4 h-10 rounded-xl bg-[#c0392b] text-white text-sm font-medium hover:bg-[#a93226] transition-colors disabled:opacity-50 shrink-0">
        <Trash2 className="w-4 h-4" /> Tüm İşletmeleri Sil
      </button>
      <Dialog open={open} onOpenChange={(v) => (v ? setOpen(true) : close())}>
        <DialogContent data-testid="delete-all-firms-dialog">
          <DialogHeader><DialogTitle className="text-[#c0392b]">Tüm işletmeler silinecek</DialogTitle></DialogHeader>
          <p className="text-sm text-[#5b4d4f]">{count} işletme ve bağlı tüm veriler kalıcı olarak silinecek. Devam etmek için şifrenizi girin ve kutuya <b>SİL</b> yazın.</p>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Patron şifreniz" data-testid="delete-all-firms-password" />
          <Input value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="SİL yazın" data-testid="delete-all-firms-confirm" />
          <DialogFooter>
            <button onClick={close} className="px-4 h-10 rounded-xl border border-[#F0DDE0] text-sm" data-testid="delete-all-firms-cancel">Vazgeç</button>
            <button onClick={run} disabled={busy || !password || confirm.trim() !== "SİL"} data-testid="delete-all-firms-submit"
              className="inline-flex items-center gap-2 px-4 h-10 rounded-xl bg-[#c0392b] text-white text-sm font-medium disabled:opacity-50">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Trash2 className="w-4 h-4" />} Kalıcı Olarak Sil
            </button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};
